import type {
  DataHealthSummary,
  EnrichmentEnrichRequest,
  EnrichmentEnrichResult,
  EnrichmentJob,
  EnrichmentQueueResponse,
  EnrichmentQueueType,
  EnrichmentSchedule,
  EnrichmentWaterfallSettings,
} from "@sales-ops-amplify/shared";
import { apiGet, apiPost, apiPut } from "./client";

export function getDataHealth(
  params?: { refreshDays?: number },
): Promise<DataHealthSummary> {
  return apiGet<DataHealthSummary>("/api/enrichment/health", params);
}

export function getEnrichmentQueue(
  type: EnrichmentQueueType,
  params?: { limit?: number; offset?: number; refreshDays?: number; q?: string },
): Promise<EnrichmentQueueResponse> {
  return apiGet<EnrichmentQueueResponse>("/api/enrichment/queues", {
    type,
    ...params,
  });
}

export function listEnrichmentJobs(
  limit = 30,
): Promise<{ jobs: EnrichmentJob[] }> {
  return apiGet("/api/enrichment/jobs", { limit });
}

export function runEnrichmentEnrich(
  body: EnrichmentEnrichRequest,
): Promise<EnrichmentEnrichResult> {
  return apiPost("/api/enrichment/enrich", body);
}

export function getEnrichmentSchedule(): Promise<EnrichmentSchedule> {
  return apiGet("/api/enrichment/schedule");
}

export function putEnrichmentSchedule(
  schedule: EnrichmentSchedule,
): Promise<EnrichmentSchedule> {
  return apiPut("/api/enrichment/schedule", schedule);
}

export function runEnrichmentScheduleNow(): Promise<EnrichmentEnrichResult> {
  return apiPost("/api/enrichment/schedule/run", {});
}

export function getEnrichmentWaterfall(): Promise<EnrichmentWaterfallSettings> {
  return apiGet("/api/enrichment/waterfall");
}

export function putEnrichmentWaterfall(
  waterfall: Partial<EnrichmentWaterfallSettings>,
): Promise<EnrichmentWaterfallSettings> {
  return apiPut("/api/enrichment/waterfall", waterfall);
}
